/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CategoryBudget = {
    properties: {
        category_id: {
    type: 'number',
    isRequired: true,
},
        category: {
    type: 'string',
    isRequired: true,
},
        budget: {
    type: 'number',
    isRequired: true,
    format: 'float',
},
        ppd: {
    type: 'number',
    isRequired: true,
},
        balance: {
    type: 'number',
    isRequired: true,
    format: 'float',
},
        glCode: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};